import { createFileRoute } from '@tanstack/react-router';
import { SavedReportsPage } from '../features/reporting/savedReports/components/SavedReportsPage/SavedReportsPage';
import { SavedReportSource } from '../features/reporting/savedReports/model';
export const Route = createFileRoute('/a/$agencyId_/reporting/saved-reports')({
  validateSearch: (search: Record<string, unknown>) => ({
    source:
      search['source'] === SavedReportSource.Shared
        ? SavedReportSource.Shared
        : SavedReportSource.Owned,
  }),
  component: AgencySavedReportsRoute,
});
function AgencySavedReportsRoute() {
  const { agencyId } = Route.useParams();
  const { source } = Route.useSearch();
  return <SavedReportsPage source={source} agencyId={agencyId} />;
}
